import React, { useState, useEffect } from 'react';
import { motivationService } from '../../services/motivationService';
import { useLanguage } from '../../contexts/LanguageContext';
import { ArrowLeft, Save, MessageCircle } from 'lucide-react';

const MessageForm = ({ message, onBack, onSuccess }) => {
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [isActive, setIsActive] = useState(true);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const { t } = useLanguage();

    useEffect(() => {
        if (message) {
            setTitle(message.title);
            setContent(message.content);
            setIsActive(message.is_active);
        }
    }, [message]);

    const validateForm = () => {
        const newErrors = {};
        if (!title.trim()) newErrors.title = t('motivationTitleRequired');
        if (!content.trim()) newErrors.content = t('motivationContentRequired');
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        try {
            if (message) {
                await motivationService.updateMessage(message.id, title, content, isActive);
            } else {
                await motivationService.addMessage(title, content, isActive);
            }
            onSuccess();
        } catch (error) {
            console.error('Mesaj kaydedilirken hata:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="message-form-container">
            <div className="form-header">
                <button className="back-btn" onClick={onBack}>
                    <ArrowLeft size={20} />
                    {t('motivationBackToList')}
                </button>
                <h2>
                    <MessageCircle size={24} />
                    {message ? t('motivationEditMessage') : t('motivationAddNew')}
                </h2>
            </div>

            <form onSubmit={handleSubmit} className="motivation-form">
                <div className="form-group">
                    <label htmlFor="title">{t('motivationMessageTitle')} *</label>
                    <input
                        type="text"
                        id="title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        className={errors.title ? 'error' : ''}
                        placeholder={t('motivationMessageTitle')}
                    />
                    {errors.title && <span className="error-message">{errors.title}</span>}
                </div>

                <div className="form-group">
                    <label htmlFor="content">{t('motivationMessageContent')} *</label>
                    <textarea
                        id="content"
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                        rows="8"
                        className={errors.content ? 'error' : ''}
                        placeholder={t('motivationMessageContent')}
                    />
                    {errors.content && <span className="error-message">{errors.content}</span>}
                </div>

                <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                        <input
                            type="checkbox"
                            checked={isActive}
                            onChange={(e) => setIsActive(e.target.checked)}
                        />
                        <span className="checkmark"></span>
                        {t('motivationIsActive')}
                    </label>
                    <p className="checkbox-help">
                        {t('motivationIsActive')} - Kullanıcılar bu mesajı görebilir
                    </p>
                </div>

                <div className="form-actions">
                    <button
                        type="button"
                        className="cancel-btn"
                        onClick={onBack}
                    >
                        {t('motivationCancelButton')}
                    </button>
                    <button
                        type="submit"
                        className="save-btn"
                        disabled={loading}
                    >
                        <Save size={16} />
                        {loading ? t('saving') : t('motivationSaveButton')}
                    </button>
                </div>
            </form>

            {/* Önizleme */}
            <div className="message-preview">
                <h3>Mesaj Önizleme</h3>
                <div className="preview-card">
                    <div className="preview-header">
                        <h4>{title || 'Mesaj Başlığı'}</h4>
                        <span className={`preview-status ${isActive ? 'active' : 'inactive'}`}>
                            {isActive ? 'Aktif' : 'Pasif'}
                        </span>
                    </div>
                    <div className="preview-content">
                        {content || 'Mesaj içeriği burada görünecek...'}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MessageForm;